import axios from 'axios'
import Vue from 'vue'
import { Message, MessageBox} from 'element-ui';
const Axios = axios.create({
  baseURL: '/api', // 设置请求baseURL
  // timeout: 5000,
  // withCredentials: true, // 是否允许带cookie这些
  // headers: {
  //   'Content-Type': 'application/json'
  // }
})
//  Axios.defaults.baseURL ='http://10.80.18.111:7070/api';
 //Axios.defaults.baseURL ='http://10.80.18.111:18001/xian';
// 请求拦截
Axios.interceptors.request.use(
  config => {
    return config;
  },
  err => {
      return Promise.reject(err);
  });

// 响应拦截
Axios.interceptors.response.use(
  response => {
    if (response.config.responseType === "blob") {
      let content = response.headers['content-disposition'];
      let fileName = content.split(';')[1];
      let name = fileName.split('=')[1];
      let left = name.split('.')[0];
      let right = name.split('.')[1];
      // store.commit('UPDATE_NAME', decodeURI(left) + '.' + right);
      return response.data
    }
    if (response.data.status === '1') {
      return response.data
    } else {
      Message({
        type: 'error',
        message: response.data.message || '系统错误'
      })
      return Promise.reject('error')
    }
  },
  err => {
      return Promise.reject(err);
  });
export default Axios



// WEBPACK FOOTER //
// ./src/api/config.js